<template>
  <div>
    <card-seplag titulo="Cadastro de chefia">
      <div class="p-col-12">
        <div class="p-grid p-fluid">
          <Rotulo nome="Buscar chefia" cols="12 4 ">
            <span class="p-input-icon-right">
              <i class="pi pi-search" />
              <InputText type="text" v-model="busca" @keyup.enter="pesquisarChefias()"
                placeholder="Digite um termo para pesquisar..." />
            </span>
          </Rotulo>
          <Rotulo cols="12 4">
            <div class="botao">
              <Button icon="pi pi-search" @click="pesquisarChefias()" label="Pesquisar" />
            </div>
          </Rotulo>
        </div>
      </div>
      <div class="p-col-12">
        <div class="p-grid p-fluid">
          <Rotulo nome=" Chefias cadastradas:" cols="12">
            <table-seplag 
            :dados.sync="dados" 
            :campos="camposTabela" 
            :hasEventoAcao="true" 
            :rows="10" 
            :paginacao="true" 
            :totalRegistro.sync="totalregistro"
             >
             <Column header="Situação" headerStyle="width: 10.vw; " bodyStyle=" ">
              <template #body="slotProps" >
                <div >
                  <span v-if="slotProps.data.flagChefia =='S'"><b class="mobile">Situação: </b>  SIM </span>  
                  <span v-else ><b class="mobile">Situação: </b>  NÃO </span>                  
                </div> 
              </template>
            </Column>
            <Column header="Ação" headerStyle="width: 3.vw; " bodyStyle=" ">
             <template #body="slotProps" >
               <div  class="p-col-12 p-md-12 p-lg-12 ">
                <Button v-if="slotProps.data.flagChefia =='S'" class="p-button-danger" icon="pi pi-times" @click="atualizarChefia(slotProps.data)"/>
                <Button v-else class="p-button-success" icon="pi pi-check" @click="atualizarChefia(slotProps.data)"/>
               </div> 
             </template>
           </Column>
          </table-seplag>          
          </Rotulo>
          <Rotulo cols="12 10" />
          <Rotulo cols="12 2">
          </Rotulo>
          <Rotulo cols="12 8" />
        </div>
      </div>
      <Dialog :visible.sync="exibirModalConfirmacao" :contentStyle="'max-width:80rem; max-height:40rem; width:40rem;'"
        :modal="true">
        <div class="p-grid p-fluid">
          <div class="p-col-12">
            <Rotulo cols="12">
              <span>
                <H3 style="text-align: center;">Deseja realmente modificar esta Chefia cadastrada?</H3>
              </span>
            </Rotulo>
            <Rotulo cols="12">
              <Button label="Alterar status da Chefia" @click="alterarChefia()" />
            </Rotulo>

          </div>

        </div>

      </Dialog>

    </card-seplag>
  </div>
</template>

<script >

import CardSeplag from '@/template/CardSeplag.vue';
import TableSeplag from '@/template/TableSeplag.vue';
import { baseApiUrl } from '@/config/global'
import Rotulo from "@/template/RotuloSeplag.vue";

export default {
  components: { CardSeplag, TableSeplag, Rotulo },

  data: function () {
    return {
      camposTabela: [
        { nome: 'codigoCargo', titulo: 'Código do cargo' ,tamanho: '10.vw', alinhamento: "left"},
        { nome: 'nomeCargo', titulo: 'Nome do cargo/função' ,tamanho: '22.vw', alinhamento: "left"},
        { nome: 'perfilCargo', titulo: 'Perfil do cargo',tamanho: '20.vw', alinhamento: "left" },
        { nome: 'especialidade', titulo: 'Especialidade' ,tamanho: '14.vw', alinhamento: "left"},
      ],
      idCargo: null,
      dados: [],
      dados2: null,
      dadosTable: [],
      dadosAtivos: null,
      exibirModal: false,
      exibirModalConfirmacao: false,
      paymentOptions: [
        { name: "Ativo", value: 'ATIVO' },
        { name: "Inativo", value: 'INATIVO' },
      ],
      codigoCargoSelecionado: null,
      flagChefiaSelecionado: null,
      cadastro: {
        codigoCargo: null,
        nomeCargo: null,
        perfilCargo: null,
        especialidade: null
      },
      chefiaSelecionada: null,
      dropdownPerfilAcesso: null,
      busca: '',
      cargoSelecionado: null,
      totalregistro: 0,
      totalElements: null
    }
  },
  methods: {
    carregarDados() {
      this.listarPerfisAcesso();
      this.listarChefiasCadastradas()
    },
    listarPerfisAcesso() {
      this.$http.get(`${baseApiUrl}/seguranca/perfilacessos/`).then(res => {
        this.dropdownPerfilAcesso = [...res.data]

      })
    },
    listarChefiasCadastradas() {
      this.$http.get(`${baseApiUrl}/especialidade/chefiasCadastrada`).then(res => {
        this.dados = res.data
      })
    },
    async pesquisarChefias() {
      if(this.busca != ""){
        this.$http.get(`${baseApiUrl}/especialidade/all?parametro=${this.busca}`).then(res => {
          this.totalregistro = res.data.length
          this.dados = res.data
          this.dados.forEach(dados => {
            if (dados.flagChefia == null) {
              dados.flagChefia = "N"
            }
          }
          )
        })
      } else {
        this.listarChefiasCadastradas()
      }
    },
    atualizarChefia(dados) {
      if (dados.flagChefia == "S") {
        dados.flagChefia = "N"
      } else if (dados.flagChefia == "N"){
        dados.flagChefia = "S"
      }

      let body = [{
        codigoCargo: dados.codigoCargo,
        especialidade: dados.especialidade,
        flagChefia: dados.flagChefia
      }]
      this.$http.put(`${baseApiUrl}/especialidade/atualiza`, JSON.stringify(body)).then(response => {
        if (response.status == 200) {
          if (dados.flagChefia == "S") {
            this.$toast.add({ severity: 'success', summary: 'Ação efetuada', detail: "Chefia atribuída com sucesso", life: 5000 })
          }
          else{
            this.$toast.add({ severity: 'success', summary: 'Ação efetuada', detail: "Chefia removida com sucesso", life: 5000 })
          }
          this.listarChefiasCadastradas()
        }else{
          this.$toast.add({ severity: 'error', summary: 'Ação não efetuada', detail: "Erro no servidor", life: 5000 })
        }   

      }
      )
    },
    AbrirModalConfirmacao() {
      this.exibirModalConfirmacao = true
    },

  },
  mounted() {
    this.carregarDados()
  },

}
</script>
<style scoped>
.botao {
  margin-top: 16px;
  
}
.mobile {
  display: none;
}
@media(max-width: 639px) {
  .mobile {
    display: block;
    /* ou inline, inline-block */
  }
}
</style>

